import { render } from "./list-plt-remote.vue?vue&type=template&id=03111d2f"
import script from "./list-plt-remote.vue?vue&type=script&lang=js"
export * from "./list-plt-remote.vue?vue&type=script&lang=js"

import "./list-plt-remote.vue?vue&type=style&index=0&id=03111d2f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__